const serviceId = 3;

const servicesById = {
  1: {
    displayName: "Zoom",
    domain: "IsZoomDown.com",
    googleTagId: "G-0X2VLFVT50",
    logoUrl: "https://www.signaltuner.com/images/is-service-down/zoom.png",
  },
  3: {
    displayName: "Microsoft Teams",
    domain: "IsMicrosoftTeamsDown.com",
    googleTagId: "G-86JJJPYSDR",
    logoUrl: "https://www.signaltuner.com/images/is-service-down/msteams.png",
  },
  41: {
    displayName: "Microsoft 365",
    domain: "IsMicrosoft365Down.com",
    googleTagId: "G-4KQLY5G16E",
    logoUrl: "https://www.signaltuner.com/images/is-service-down/microsoft365.png",
  },
};

const activeService = servicesById[serviceId];

if (!activeService) {
  throw new Error(`Missing is-service-down configuration for serviceId ${serviceId}.`);
}

const config = {
  API_URL: "https://signaltuner-back.azurewebsites.net/api/User",
  // API_URL: "https://localhost:7090/api/User",
  serviceId,
  serviceLogoURL: activeService.logoUrl,
  service: {
    ...activeService,
    metaDescription: `Is ${activeService.displayName} down right now? Check the current status of ${activeService.displayName}. Sign up for live alerts at ${activeService.domain}.`,
    title: `Is ${activeService.displayName} Down? Check ${activeService.displayName} Status Live | ${activeService.domain}`,
  },
  servicesById,
};

export default config;
